import { render, staticRenderFns } from "./ChangelogButton.vue?vue&type=template&id=5c608d66&scoped=true&"
import script from "./ChangelogButton.vue?vue&type=script&lang=js&"
export * from "./ChangelogButton.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogButton.vue?vue&type=style&index=0&id=5c608d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c608d66",
  null
  
)

export default component.exports